import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapGetters } from 'vuex';
export default {
  name: 'BasicLayout',
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['keepAliveArrs', 'getForwardPage'])), {}, {
    hasNoHead: function hasNoHead() {
      if (this.$route.meta && this.$route.meta.hasAppHead) {
        return false;
      } else {
        // 如果是app通过forward页面打开的不隐藏头
        if (this.getForwardPage && this.$Utils.appInfo) {
          return false;
        }
        return !!(this.$Utils.wechatInfo() || this.$Utils.appInfo);
      }
    }
  })
};